import { Attributes } from '@leverege/ui-attributes';
import Types from "../../constants/Types.js";
export default {
  name: 'name',
  objectType: Types.firmwareComponent,
  valueType: 'string',
  get: (data, cxt) => {
    if (!data) {
      return null;
    }
    return `${Attributes.get('type', Types.firmwareComponent, data)}:${Attributes.get('version', Types.firmwareComponent, data)}`;
  },
  displayName: 'Name',
  source: {
    type: Types.apiName,
    editable: false,
    creatable: false
  }
};